import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent, MatDialog, MatSort, MatSnackBar, MatTab } from '@angular/material';
import { trigger, transition, style, animate, useAnimation } from '@angular/animations';
import { bounce } from 'ng-animate';
import { from, Observable } from 'rxjs';
import { AccidentService } from '../../services/accident.service'
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component'
import { learnerAssignmentL2, learnerAssignmentL3, assignmentStatus, months } from '../../_models/staticArray'
import { LearnerSingleWeekComponent } from '../../time-sheet/learner-single-week/learner-single-week.component'
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/*service here */
import { FilterService } from 'src/app/services/filter.service';
import { MaterialService } from '../../services/material.service';
import { LearnerService } from '../../services/learner.service';
import { JobService } from '../../services/jobs/job.service';
import { CourseService } from '../../services/course.service';
import { QuizService } from '../../services/quiz.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import * as _ from 'lodash';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import { TestedIndividualService } from 'src/app/services/tested-individual.service'
import { UtilityService } from '../../services/utility.service'
import { TimeSheetService } from 'src/app/services/time-sheet.service';
import { AssetService } from 'src/app/services/asset.service';
import { UserSingleWeekComponent } from 'src/app/time-sheet/user-single-week/user-single-week.component';
import { UserRoleService } from 'src/app/services/user-role.service';
import { CompetenciesService } from '../../services/competencies.service';
import { config } from 'src/app/config';
declare var $: any;

export const FLIP_TRANSITION = [
  trigger(
    'inOutAnimation',
    [
      transition(
        ':enter',
        [
          style({ opacity: 0 }),
          animate('0.5s ease-in-out',
            style({ opacity: 1 }))
        ]
      ),
      transition(
        ':leave',
        [
          style({ opacity: 1 }),
          animate('0s ease-in',
            style({ opacity: 0 }))
        ]
      )
    ]
  ),
  trigger('bounce', [transition('* => *', useAnimation(bounce))]),
];




@Component({
  selector: 'app-learner-dashboard',
  templateUrl: './learner-dashboard.component.html',
  styleUrls: ['./learner-dashboard.component.scss'],
  animations: [FLIP_TRANSITION]
})
export class LearnerDashboardComponent implements OnInit {

  // @ViewChild(UserSingleWeekComponent, { static: false }) timeSheet: UserSingleWeekComponent;
  @ViewChild(UserSingleWeekComponent, { static: false }) timeSheet: UserSingleWeekComponent;

  @Input('isActive') isActive: Boolean;
  @Input('location') location: any;
  @Output() AccidentLength: EventEmitter<any> = new EventEmitter<any>();

  backupLocation;
  bounce: any;
  statusArray = [];
  finalAss = [];
  examArray = [];
  jobId;
  loadingMaterials: Boolean;
  learner;
  learnerCopy
  learnerName = '';
  loading = false;
  materialId = [];
  searchText;
  searchtext;
  assignments: any = [];
  courseId;
  material: any = [];
  job;
  profilePath;
  mobile;
  email;
  panelOpenState = true;
  currentUser;
  userFilter: any = { title: '' };
  displayedColumns: string[] = ['displayTitle', 'type', 'deadlineDate', 'Status', 'View'];
  displayColumns: any[] = ['Copy', 'Week Number', 'Week Start', 'Week End', 'Hours Worked', 'Details of Work Complete', 'Reflection', 'Edit', 'Reset', 'View']
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  pageEvent: PageEvent;
  learnerId: any;
  filteredData: any = [];
  assignmentsCopy: any = [];
  selectedTab = 0
  loadingJobs;
  loadingAssignments;
  loadingLearners;
  user;
  filterActive = false;

  // displayColumns: any[] = ['Copy', 'Week Number', 'Week Start', 'Week End', 'Hours Worked', 'Details of Work Complete', 'Reflection', 'Edit', 'Reset', 'View']
  // displayColumns: string[] = ['copyPaste', 'weekNumber', 'weekStart', 'weekEnd', 'hoursWorked', 'details', 'otherDetails', 'edit', 'reset', 'view']
  displayedExams: string[] = ['title', 'marks'];
  examSource: MatTableDataSource<any>;
  examPaginator: MatPaginator;
  examSort: MatSort;
  exams: any[];
  totalOTJH: any

  noMaterial = {
    title: "No Materials!",
    data: "Not added any reading materials"
  }

  noSearchMaterial = {
    title: "No Materials!",
    data: "Sorry, no materials matched your search"
  }

  noMarks = {
    title: "No Marks!",
    data: "Sorry, no exam marks added yet"
  }

  noAllotment = {
    title: "No Materials!",
    data: "Sorry, no materials found!"
  }
  nojob = {
    title: "No Jobs!",
    data: "Sorry, you are not added in any job!"
  }
  isAccident
  userDetails: any;
  isTestedIndividual: boolean = false;
  candidates: any;
  showNonMedical: boolean = true;
  showMedicalForm: boolean = false;
  courseType: any;
  isPolicyAccepted: any;
  learnersJob = []
  displayTabs = false
  activities = []
  hasPolicy: any;
  summarySheetEdit = {}
  assessmentPlanEdit = {}
  currentJob
  courseComponet
  selectedMonths;
  isStaff: boolean = false

  assignmentStatusL2 = learnerAssignmentL2
  assignmentStatusL3 = learnerAssignmentL3
  materialType = assignmentStatus
  jobType

  selStatus
  trackTime: any;
  isExamTab: boolean
  months = months
  isIlpForm: boolean
  // [{ id: '0', name: 'January' }, { id: '1', name: 'February' }, { id: '2', name: 'March' }, { id: '3', name: 'April' }, { id: '4', name: 'May' }, { id: '5', name: 'June' },
  // { id: '6', name: 'July' }, { id: '7', name: 'August' }, { id: '8', name: 'September' }, { id: '9', name: 'October' }, { id: '10', name: 'November' }, { id: '11', name: 'December' }]
  datesRange;
  allWeeks: any[];
  selectedWeeks: any;
  doCalWeekDates = true;
  weekDates: unknown;
  monthChanged: boolean;
  courseFolderList = []
  selectedCourse: any
  courseUnitId
  allAllotmentList = []
  materialStatusArray: any = ["Assignment", "Reading"];
  isAssignment: boolean = true
  monthChangeDates
  operativeUserDetails
  updatedInstructor: any;
  // isAssignment: boolean = false;
  // evidenceList
  // isMonthClear
  isClearBtnShow: boolean = false;
  datesRanges: any;
  currentDate: any;

  // isMonthClear
  isMonthClear: boolean = false
  evidenceList: any = [];
  timeSheetData: any
  userRole: string;
  isLoading: boolean = false;
  qrURL
  isPOCTForm = false;
  isBreathAlcoholForm = false;

  // qrURL = config.clientUrl + 'digital-card/' + this.learnerId + '?Digital=true&type=learner'
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild('ExamSort', { static: true }) set newSort(ExamSort: MatSort) {
    this.examSort = ExamSort;
  };


  @ViewChild('materialTab', { static: true }) tabs: MatTab


  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  private getSingleJob: Subject<any> = new Subject<any>();
  // public _competencyService: CompetenciesService
  constructor(public _testedIndividualService: TestedIndividualService, public _accidentSerive: AccidentService, public _snackBar: MatSnackBar, public dialog: MatDialog, private activatedRoute: ActivatedRoute, public _materialService: MaterialService, public _learnerService: LearnerService, public _jobService: JobService, public _courseService: CourseService, private router: Router, public _userRoleService: UserRoleService,
    public _filter: FilterService, public _mpjobService: MpjobService, public cd: ChangeDetectorRef, public _quizService: QuizService, private _timeSheetService: TimeSheetService, private config: NgSelectConfig, public _utilityService: UtilityService, public _assetService: AssetService, public _competencyService: CompetenciesService) {
    // this.bgColors = ["bg-red", "bg-teal", "bg-blue", "bg-yellow", "bg-pink"];
    this.dataSource = new MatTableDataSource<any>(this.assignments);
    this.examSource = new MatTableDataSource<any>(this.exams);
    this.activatedRoute.params.subscribe(params => {
      console.log("PARAS IN CONSTUCTOR ==========>", params);
      this.learnerId = params.id;
    })

    this._learnerService.getSingleJobId()
      .pipe(
        takeUntil(this.getSingleJob)
      )
      .subscribe(res => {
        console.log("when job change from drop down from top nav", res);
        if (res) {
          this.jobId = res.jobId
          this.router.navigate(['/user/' + this.learnerId], { queryParams: { job: this.jobId } });
          //this.getJob()
        }
      })
  }

  ngOnDestroy() {
    this.getSingleJob.next();
    this.getSingleJob.complete();

  }



  ngOnInit() {
    console.log("ON INIT FIRST LEARENER ID ====>", this.learnerId);
    // this.isAccident = true;
    this.currentUser = JSON.parse(localStorage.currentUser);
    console.log("current user ==>", this.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("login user details", this.user);

    this.activatedRoute.queryParams.subscribe(qparams => {

      console.log('qparams In Leaner Dashboard', qparams);
      // this.jobId = qparams.job
      if (qparams && qparams.isTestedIndividual && qparams.isTestedIndividual) {

      } else {
        this.jobId = qparams.job
        // this.getAllotments('first');
        this.getJob()
        this.getEvidenceList()
        this.showNonMedical = true
      }


      if (qparams && (qparams.isTestedIndividual == true || qparams.isTestedIndividual == 'true') && (qparams.isLearner == true || qparams.isLearner == 'true') && (qparams.formType === 'isMedical')) {
        console.log("call this first tab");
        this.selectedTab = 5
        this.isTestedIndividual = true
        this.jobId = qparams.jobId
        this.showMedicalForm = true
        this.loading = true;
        this.showNonMedical = false
        this.getAllotments();
      }

      if (qparams && (qparams.isTestedIndividual == true || qparams.isTestedIndividual == 'true') && (qparams.isLearner == false || qparams.isLearner == 'false') && (qparams.formType === 'isMedical')) {
        console.log("this is for medical learner", qparams);

        this.isTestedIndividual = true
        this.jobId = qparams.jobId
        this.showNonMedical = false
        this.showMedicalForm = true
        this.loading = true;
        this.getTestedIndividual();
        this.selectedTab = 5
        // document.getElementById("mat-tab-label-0-0").hidden = true;
      }
      if (qparams && qparams.formType === 'isBreath') {
        this.isTestedIndividual = true
        this.isBreathAlcoholForm = true
        this.showMedicalForm = false
        this.showNonMedical = false
        this.selectedTab = 1
        this.jobId = qparams.jobId
        this.getTestedIndividual();
      }

      if (qparams && qparams.formType === 'isPoct') {
        this.isTestedIndividual = true
        this.isBreathAlcoholForm = false
        this.isPOCTForm = true
        this.showMedicalForm = false
        this.showNonMedical = false
        this.selectedTab = 1
        this.jobId = qparams.jobId
        this.getTestedIndividual();
      }

      if (!qparams['currentTab']) {
        console.log("in IF qparams['currentTab']", qparams['currentTab'])
        // this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { currentTab: 0 } });
      }
      else this.selectedTab = qparams['currentTab']

      if (qparams.isTestedIndividual == true || qparams.isTestedIndividual == 'true') {

        this.isAccident = false;
        this.isAssignment = false;
        // $(".all-theme-tab .mat-tab-labels .mat-tab-label:first-child").attr('hidden', true);
        console.log("call this condition", this.tabs);
        this.tabs.disabled = true
        // this.tabs.reling
        // this.tab.position
      } else {
        this.isAssignment = true;
        this.isAccident = true;
        // $(".all-theme-tab .mat-tab-labels .mat-tab-label:first-child").attr('hidden', false);
      }
    })


    console.log("data of assignment", this.isAssignment);

    this.loadingMaterials = true;




    this.getCurrentMonthWeeks()
    // this.generateMonthWeeks()
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    console.log('Filter Value==>', filterValue, this.assignments)
    console.log("filter array value check=====================>")
    if (filterValue == '') {
      this.updateData(this.assignments)
    } else {
      let finalarray = [];
      // this.assignments.forEach((e1) => {

      //   console.log("e1====>>>>>", e1)

      //   // console.log("e1====>>>>>", e1.assignment.assignmentNo)
      //   let string = e1.assignment.title;
      //   let result = string.match(filterValue);
      // console.log("resul check this file ========>", result)
      finalarray = this._filter.filter(filterValue, this.assignments, ['title', 'unitNo', 'assignmentNo']);
      console.log("final array to print", finalarray);


      // if (e1.assignment.assignmentNo == filterValue || e1.assignment.unitNo == filterValue || e1.assignment.title == filterValue) {
      //   finalarray.push(e1)
      // }
      // })
      console.log("final updated array==============>", finalarray)
      this.updateData(finalarray);
    }
  }
  policyAcceptedResponse(event) {
    console.log("policyAcceptedResponse =============> ", event)
    this.openSnackBar("Policy signed successfully!", "OK")
    $(".learners_tab .mat-tab-labels .mat-tab-label:first-child").attr('hidden', false);
    this.selectedTab = 0
    this.isPolicyAccepted = true

  }

  selectedStatus(event) {
    console.log("status of checked event", status);
    this.filterActive = true
    // if (event == true) { 
    //   this.statusArray.push(status);
    // }
    // if (event == false) {
    //   let index = this.statusArray.indexOf(status);
    //   if (index !== -1) this.statusArray.splice(index, 1);
    // }
    if (!this.statusArray.length) {
      this.filterActive = false
      // this.updateData(this.assignments);
      if (this.materialStatusArray.length) {
        const finalarray = [];
        this.assignments.forEach((e1) => this.materialStatusArray.forEach((e2) => {
          if (e1.assignment.type == e2) {
            finalarray.push(e1)
          }
        }));
        this.updateData(finalarray);
      } else {
        this.updateData(this.assignments);
      }

    } else {
      console.log("what is total assignments", this.assignments);
      console.log("status array", this.statusArray);

      const finalarray = [];
      this.assignments.forEach((e1) => this.statusArray.forEach((e2) => {
        if (e1 && e1.totalQuiz) {
          let temp = e1.totalQuiz.filter((x) => x.status == e2)
          if (temp && temp.length) {
            finalarray.push(e1)
          }
        } else {
          if (e1.status == e2) {
            finalarray.push(e1)
          }
        }


        console.log("what is final array", finalarray);



      }));
      this.updateData(finalarray);
    }
  }


  fileDetails(event) {
    // this.getFileDetails.emit(event)
    // this.openCompPanel.emit(event)
    this._competencyService.openCompetencyFile(event)
    console.log("getFileDetails event emitted from single-instructor", event);
  }

  materialStatus(event, status) {
    this.filterActive = true
    // console.log("event when checkd", event);
    console.log("what is the statuys", status);
    console.log("this.materialStatusArray", this.materialStatusArray)
    // console.log("assignments list", this.assignments);
    // console.log("material status array", this.materialType);

    // let finalArray = []

    if (this.materialType[0].checked == true) {
      this.isAssignment = true
    } else {
      this.isAssignment = false
    }

    if (event == true) {
      this.materialStatusArray.push(status);
    }
    if (event == false) {
      let index = this.materialStatusArray.indexOf(status);
      if (index !== -1) this.materialStatusArray.splice(index, 1);
    }
    if (!this.materialStatusArray.length) {
      this.filterActive = false
      this.updateData(this.assignments);
    } else {
      // console.log("what is total assignments", this.assignments);
      // console.log("status array", this.materialStatusArray);

      const finalarray = [];
      this.assignments.forEach((e1) => this.materialStatusArray.forEach((e2) => {
        if (e1.assignment.type == e2) {
          finalarray.push(e1)
        }
      }));
      this.updateData(finalarray);
    }

  }

  deleteAllotment(allotmentId, learnerId) {
    console.log("single job id", this.jobId);

    this.openDialog(DeleteConfirmModalComponent, "Assignment").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        console.log('Delete Allotment Calling', allotmentId, learnerId);
        const data = { allotmentId: allotmentId, learnerId: learnerId, jobId: this.jobId }
        this._learnerService.deleteAllotment(data).subscribe(res => {
          console.log('Success Response-->', res);
          this.getAllotments();
        }, err => {
          console.log('Error in api calling-->', err);
        })
      }
    })
  }

  generateMonthWeeks() {
    this.selectedWeeks = []
    this.monthChanged = true
    console.log("generateMonthWeeks called")
    this._timeSheetService.generateMonthWeeks(this.selectedMonths).then((res: any) => {
      this.allWeeks = res.allWeeks
      this.datesRange = res.datesRange
      this.monthChangeDates = res.datesRange
      console.log("Response from time sheet service;", res)
    }).catch((err) => {
      console.log('err', err)
    })
  }

  getCurrentMonthWeeks() {
    this._timeSheetService.getSystemDate().subscribe(date => {
      console.log('system Date', date)
      this.currentDate = date.systemDate
      let d = new Date(date.systemDate);
      const n = this.months[d.getMonth()];
      console.log('this is the current month ', [n])
      this._timeSheetService.generateMonthWeeks(n).then((res: any) => {
        console.log("res in get current week", res);

        this.allWeeks = res.allWeeks
        this.datesRanges = res.datesRange
        this.weekDates = res.datesRange
        // this.learnerCopy = this.learner
        console.log("this.datesRange", this.datesRange);
        console.log("this.weekDates", this.weekDates);

        // console.log("Response from time sheet service;", this.learner)
      }).catch((err) => {
        console.log('err', err)
      })

    })
  }

  generateWeekDates() {
    console.log("**generatingWeekDates");
    this.monthChanged = false
    console.log("this.selectedWeeks", this.selectedWeeks)
    this._timeSheetService.generateWeekDates(this.selectedWeeks).then((res: any) => {
      this.doCalWeekDates = false
      this.weekDates = res.weekDates
    }).catch((err) => {
      this.doCalWeekDates = false
    })
  }
  clearMonth() {
    this.isMonthClear = true
    this.monthChanged = true
    this.doCalWeekDates = true
    // this.selectedWeeks = []
    this.datesRange = []
    // this.monthChangeDates = []
    // // this.datesRange = []
    // this.getCurrentMonthWeeks()
    console.log("current date data", this.currentDate);

    let d = new Date(this.currentDate);
    const n = this.months[d.getMonth()];
    console.log('this is the current month ', [n])
    this._timeSheetService.generateMonthWeeks(n).then((res: any) => {
      console.log("res in get current week", res);

      // this.allWeeks = res.allWeeks
      // this.datesRange = res.datesRange
      // this.weekDates = res.datesRange

      this.monthChangeDates = res.datesRange
      // this.learnerCopy = this.learner
      console.log("this.datesRange", this.datesRange);
      console.log("this.weekDates", this.weekDates);

      // console.log("Response from time sheet service;", this.learner)
    }).catch((err) => {
      console.log('err', err)
    })

  }
  clearWeek() {
    this.doCalWeekDates = true
  }

  /**
   * ***************************************
   * Accident Active Tab 
   */

  eventFromAccidentTab(event) {
    console.log("here is accident Tab Flag check", event)
    this.isAccident = event.isAccident;
    this._accidentSerive.displayAccidentTab({ isAccident: event.isAccident })

  }
  // UTILITY


  updatedData(event) {
    console.log("hellllllllllllllllo");
    console.log("value of event--------->", event);
    this.updatedInstructor = event.data
  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px', height: '600px' });
    return dialogRef.afterClosed();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  checkStatus() {
    if ((this.user && (this.user.isAdmin || this.user.isLearner)) || this.isPolicyAccepted) {
      return false
    } else {
      // console.log("details of isPolicyAccepted", this.isPolicyAccepted);

      return true
    }
  }

  // UPDATE TABLES
  updateData(assignment) {//Assignment table
    console.log("assignment list data", assignment);

    this.dataSource = new MatTableDataSource(assignment);
    this.finalAss = assignment;

    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property)
      switch (property) {
        case 'displayTitle': return item.assignment.title
        case 'deadlineDate': return item.deadlineDate;
        case 'type': return item.assignment.type
        case 'status': return item.status

        default: return item[property]
      }
    }
    // console.log("Assignment in updateData", assignment)
    if (assignment == undefined) {
      // console.log("in if that is assignment == undefined")
      this.finalAss = []
      // console.log("this.finalAss in updateData and if", this.finalAss)
    }
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    // console.log("data shorting here ========>",this.data)
  }
  updateExams(exams) {//Exam table
    this.examArray = exams;
    console.log('examArray========>', this.examArray)
    if (this.examArray != null) {
      this.examSource = new MatTableDataSource(exams);
      this.examSource.sort = this.examSort;
    }
  }
  changeParams(event) { //Tabs change
    console.log("Tab changed =====>>>>> ", event)
    this._assetService.closeDisplayFile(true)
    // this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { currentTab: event.index } });
  }


  checkCurrentPolicy(name) {
    // console.log("what is the current job value for more", name);
    // this.courseComponet = name;

    if (this.currentJob && this.currentJob.course.courseMetaId && this.currentJob.course.courseMetaId.components && this.currentJob.course.courseMetaId.components.length) {
      let temp = this.currentJob.course.courseMetaId.components.includes(name)
      // console.log("check current job value",this.currentJob)
      // console.log("temp value after checked", temp, this.currentJob);
      // if (temp == true) {
      return temp
      // } else {
      //   return false
      // }
    } else {
      return false
    }

  }


  checkLevel2Policy(policy) {
    // console.log("value of course meta", this.currentJob);
    if (this.currentJob && this.currentJob.course.courseMetaId && this.currentJob.course.courseMetaId.components && this.currentJob.course.courseMetaId.components.length) {
      //  console.log("value of course meta", this.currentJob);

      let temp = this.currentJob.course.courseMetaId.components.includes(policy)

      // console.log("temp value after checked", temp); 
      if (temp && this.showNonMedical && this.hasPolicy && !this.isPolicyAccepted) {
        return true

      } else {
        return false
      }
    } else {
      return false
    }
  }

  displayAssignment() {
    return true
  }


  datesSelected(event) {
    // this.loading = true
    this.isClearBtnShow = false
    console.log("date select event", event);
    this.isClearBtnShow = false
    let d1 = event.startDate
    let d2 = event.endDate

    if (d1 != null || d2 != null) {
      this.isClearBtnShow = true
      this._timeSheetService.filterDates(event.startDate, event.endDate, this.currentDate).then((response: any) => {
        // this.loading = true
        console.log("response of dates list", response);
        this.isClearBtnShow = true
        this.allWeeks = response.allWeeks
        this.datesRange = response.datesRange
        this.monthChangeDates = response.datesRange
        // this.loading = false
      }, err => {
        console.log("err", err);

      })
    } else {
      // this.getCurrentMonthWeeks()
      let d = new Date(this.currentDate);
      const n = this.months[d.getMonth()];
      console.log('this is the current month ', [n])
      this._timeSheetService.generateMonthWeeks(n).then((res: any) => {
        console.log("res in get current week", res);
        this.monthChangeDates = res.datesRange
        // this.learnerCopy = this.learner
        console.log("this.datesRange", this.datesRange);
        console.log("this.weekDates", this.weekDates);

        // console.log("Response from time sheet service;", this.learner)
      }).catch((err) => {
        console.log('err', err)
      })
    }
  }


  checkStatusAssign(status) {
    console.log("CHECK STATUS", status)
  }

  // REDIRECTION

  goToSingleAllotment(learner) { // WHEN ASSIGNMENT TABLE ROW CLICKED
    console.log("learner data", learner);

    // this.router.navigateByUrl('/learnerAllotment/' + learner._id)

    if (learner.assignment && learner.assignment.type == 'Assignment') {

      let userRole = this.getUserRole()
      console.log("userRole !!!!  ", this.userRole);
      let count = 0
      if (this.userRole == 'admin') count = 0
      else if (this.userRole == 'trainer') count = 1
      else if (this.userRole == 'IQA') count = 2
      else if (this.userRole == 'learner') count = 3
      else if (this.userRole == 'client') count = 4
      let param = {
        userRole: count
      }
      if (this.userRole === 'learner' && learner.totalQuiz && learner.totalQuiz.length) {
        let status = learner.totalQuiz[0].status
        console.log("WHAT IS THE STATUS", status)
        if (status === 'Pending') {
          this.router.navigate(['/learner/allotment/' + learner._id], { queryParams: param })
        }
      } else {
        this.router.navigate(['/learner/allotment/' + learner._id], { queryParams: param })
      }
      // this.router.navigateByUrl('/learnerAllotment/' + learner._id)
    } else {

      let navigationExtras: NavigationExtras = {
        state: {
          material: learner.assignment
        }
      };
      this.router.navigateByUrl('/learner/readingMaterial/' + learner.assignment._id, navigationExtras);

    }

  }


  async singleAssignment(allotment) {
    console.log("allotment", allotment);
    if (allotment.assignment && allotment.assignment.type == 'Assignment') {
      // this.router.navigateByUrl('/learnerAllotment/' + allotment._id)
      console.log("hello single allotment job ===>", this.job)
      let userRole = await this.getUserRole()
      console.log("userRole !!!!  ", this.userRole);
      let count = 0
      if (this.userRole == 'admin') count = 0
      else if (this.userRole == 'trainer') count = 1
      else if (this.userRole == 'IQA') count = 2
      else if (this.userRole == 'learner') count = 3
      else if (this.userRole == 'client') count = 4
      let param = {
        userRole: count
      }
      console.log("what is params value", param);

      // let navigationExtras: NavigationExtras = {
      //   state: {
      //     job: this.job,
      //   }
      // };
      this.router.navigate(['/learner/allotment/' + allotment._id], { queryParams: param })
    } else {

      let navigationExtras: NavigationExtras = {
        state: {
          material: allotment.assignment
        }
      };
      this.router.navigateByUrl('/learner/readingMaterial/' + allotment.assignment._id, navigationExtras);

    }


  }


  showMaterialFiles(material) { //When clicked on a material from materials tab
    let navigationExtras: NavigationExtras = {
      state: {
        material: material
      }
    };
    this.router.navigateByUrl('/learner/readingMaterial/' + material._id, navigationExtras);
  }

  getUserRole() {
    if (this.job && this.job.length) {
      let getRole = this._userRoleService.getUserRole(this.job[0].instructors, 'job');

      console.log("getRole ?? ", getRole);
      if (getRole.isAdmin) this.userRole = 'admin'
      else if (getRole.isLearner) this.userRole = 'learner'
      else if (getRole.isClient) this.userRole = 'client'
      else if (getRole.isTrainer) this.userRole = 'trainer'
      else if (getRole.isIQA) this.userRole = 'IQA'
    }
  }

  downloadQRcode(parent) {
    let qrImage = document.getElementsByTagName('canvas')[0]
    let finalTest = this.trimCanvas(qrImage)
    let blobData = this.convertBase64ToBlob(finalTest);
    const blob = new Blob([blobData], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.learner.name + '-QR';
    link.click();
  }



  trimCanvas(c) {
    let ctx = c.getContext('2d'),
      copy = document.createElement('canvas').getContext('2d'),
      pixels = ctx.getImageData(0, 0, c.width, c.height),
      l = pixels.data.length,
      i,
      bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
      },
      x, y;

    // Iterate over every pixel to find the highest
    // and where it ends on every axis ()
    for (i = 0; i < l; i += 4) {
      if (pixels.data[i + 3] !== 0) {
        x = (i / 4) % c.width;
        y = ~~((i / 4) / c.width);

        if (bound.top === null) {
          bound.top = y;
        }

        if (bound.left === null) {
          bound.left = x;
        } else if (x < bound.left) {
          bound.left = x;
        }

        if (bound.right === null) {
          bound.right = x;
        } else if (bound.right < x) {
          bound.right = x;
        }

        if (bound.bottom === null) {
          bound.bottom = y;
        } else if (bound.bottom < y) {
          bound.bottom = y;
        }
      }
    }

    // Calculate the height and width of the content
    let trimHeight = bound.bottom - bound.top,
      trimWidth = bound.right - bound.left,
      trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);
    console.log("trimmed", trimmed)
    //  this.testdata = trimmed.data
    copy.canvas.width = trimWidth;
    copy.canvas.height = trimHeight;
    copy.putImageData(trimmed, 0, 0);

    // Return trimmed canvas
    console.log('copy.canvas;', copy.canvas.toDataURL())
    console.log(" copy.putImageData(trimmed, 0, 0);", copy.putImageData(trimmed, 0, 0))
    // this.testdata = copy.canvas.toDataURL()
    return copy.canvas.toDataURL();
  }

  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }

  // API 
  getJob() { //isLearner
    console.log("what is the job id", this.jobId);

    if (this.jobId) {
      this._jobService.getJobById(this.jobId).subscribe((job) => {
        console.log("%cRecieved job", "color:blue", job.data, typeof job.data)
        this.job = job.data;

        this.getUserRole()
        console.log("job data details===========", this.job);
        if (this.job && this.job.length) {
          this.courseType = this.job ? this.job[0].course.type : ''
          this.trackTime = this.job[0].course.trackHours
          this.isExamTab = this.job[0].course.hasExam
          this.isIlpForm = this.job[0].course.hasIlpForm
        }
        if (this.courseType == 'Level2') {
          this.getPolicyData()
          console.log("first if part");
          this.hasPolicy = this.job[0].course.courseMetaId.hasPolicy
          this.displayTabs = true;
        } else {
          console.log("secobd if part");
          // $(".learners_tab .mat-tab-labels .mat-tab-label:first-child").attr('hidden', false);
          this.displayTabs = false
          this.getPolicyData()
        }
        job.data.forEach((job) => {
          if (this.jobId == job._id) {
            this.courseId = job.course._id;
          }
        })
        // this.getMaterials();
        if (job.data.length) {
          // this.getMaterials();
          this.getAllotments();
        } else {
          this.router.navigate(['server-error'])
        }
      })
    }
  }
  getTypeColor(type) {
    if (type == 'Assignment')
      return "Assignmet"

    else
      return "Reading"
  }

  getStatusColor(status) {
    // console.log("what is status", status);

    if (status || status != undefined) {
      switch (status) {
        case 'Submitted':
          // this.tooltip = 'Submitted';
          return 'Submitted'
          break;

        case 'Completed':
          // this.tooltip = 'Completed';
          return 'Completed'
          break;

        case 'Requested for Resubmission':
          // this.tooltip = 'Request for Resubmission';
          return 'Requested'
          break;

        case 'Re-Submitted':
          // this.tooltip = 'Re-Submitted';
          return 'Re-submitted'
          break;
        case 'Re-submitted':
          // this.tooltip = 'Re-Submitted';
          return 'Re-submitted'
          break;

        case 'Saved':
          // this.tooltip = 'Saved';
          return 'saved'
          break;

        default:
          // this.tooltip = 'Pending';
          return 'Pending'
          break;
      }
    } else {
      // console.log("call this else part", ' ');

      // this.tooltip = 'Pending';
      return 'Pending'
    }
  }


  getQuizByCourseId() {
    // this.loading = false
    // this._quizService.getQuizByCourseId(this.courseId).subscribe(res => {
    //   console.log("QUIZZES IN UNITS", res)
    //   this.activities = res
    //   this.loading = false
    // })
  }

  appearQuiz(quizId) {
    console.log("quiz id======", quizId);

    // appear - quiz
    this.router.navigate(['/appear-quiz'], { queryParams: { quizId: quizId, learnerId: this.learnerId } })
  }


  checkCondition() {
    if (this.courseType == 'Level3') {

      console.log("     calling", this.courseType);
      return false
    } else {
      console.log("only else");
      return true
    }

  }


  changedUnit(event) {
    console.log("what is the course-folder id ", this.courseUnitId);
    console.log("this is the total list of allotments", this.material);
    this.assignments = []
    this.allAllotmentList.forEach((item) => {
      // console.log(" Tasg taga  assignment", assignment)
      if (item.assignment.courseFolder == this.courseUnitId) {
        this.assignments.push(item)
      }
      // this.assignments = tempJobs[foundJobIndex].allotments;
    })
    this.material.forEach((item) => {
      // console.log(" Tasg taga  assignment", assignment)
      if (item.courseFolder == this.courseUnitId) {
        let obj = {
          assignment: item
        }
        this.assignments.push(obj)
        // this.assignments.push(item)
      }
      // this.assignments = tempJobs[foundJobIndex].allotments;
    })
    console.log("FINAL ASSIGNMENT LIST", this.assignments)
    this.assignmentsCopy = this.assignments;
    this.updateData(this.assignments)

  }



  getMaterials() { //isLearner
    this.loading = true;
    this.material = []
    if (this.courseId) {
      this._courseService.getCourse(this.courseId).subscribe((material) => {
        console.log("RECIEVED", material)
        let recievedMaterial = material.pop()
        if (recievedMaterial) {
          recievedMaterial.materials.forEach((material) => {
            if (material.type == "Reading") {
              this.material.push(material);
            }
          })
          console.log("this is the reading material list", this.material);

        }
        this.loading = false;
        this.loadingMaterials = false;
      })
    }
    else {
      this.loading = false;
      this.loadingMaterials = false;
    }

  }
  getAllotments(item?) { //isLearner

    console.log("this is the api call from another", item);


    this.loading = true;
    this.activatedRoute.params.subscribe(params => {
      console.log(params['id']);
      this.learnerId = params['id'];
      this.qrURL = config.clientUrl + 'digital-card/' + this.learnerId + '?isDigital=true'
      console.log("++++++++++", this.learnerId, this.jobId);
      this._learnerService
        .getLearner(params['id'], this.jobId)
        .subscribe(data => {
          console.log("RECEIVED = ", data);
          this.learner = data.pop();
          let tempData = {
            user: this.learner,
            jobId: this.jobId
          }
          this.timeSheetData = tempData

          if (this.learner && this.learner.operativeUser) this.operativeUserDetails = this.learner.operativeUser

          console.log("selected job data", this.job);
          if (this.job && this.job.length) {

            let courseId = this.job[0].course._id
            if (courseId == '5ecd0b8e943959723eebba15' && this.learner.isPolicyAccepted == false) {
              $(".learners_tab .mat-tab-labels .mat-tab-label:first-child").attr('hidden', true);
              this.selectedTab = 1
            } else {
              $(".learners_tab .mat-tab-labels .mat-tab-label:first-child").attr('hidden', false);
              this.selectedTab = 0
            }
          }

          if (this.learner && this.learner.operativeUser) {
            this.isStaff = true
          } else {
            this.isStaff = false
          }


          if (this.learnerId) this.instructorJobs()
          if (this.learner) {
            this.learnerName = this.learner.name;
            this.mobile = this.learner.phone;
            this.email = this.learner.email;
            this.isPolicyAccepted = this.learner.isPolicyAccepted ? this.learner.isPolicyAccepted : false
            this.profilePath = this.learner.profilePic;

            console.log(" *********** learner Data here check ***** ", this.learner)

            if (this.learner.job && this.learner.job.length) {
              this.learnersJob = this.learner.job
              this.sendJobsToEditInstructorModal()
            }

            console.log(" yash check this jobId ", this.jobId)

            if (this.jobId) {
              console.log(" Job Selected ", this.jobId, this.learner.totalOTJH)
              let tempJobs = JSON.parse(JSON.stringify(this.learner.job))
              let currentJobId = this.jobId
              let otjtHours = this.learner.totalOTJH.find((x) => {
                if (x._id == this.jobId) return x
              })
              console.log("otjtHours testing", otjtHours);
              if (otjtHours != undefined) {
                this.totalOTJH = otjtHours.totalOTJH ? otjtHours.totalOTJH : '00:00'
              }

              console.log("this is the final totalOTJH", this.totalOTJH);

              let foundJobIndex = _.findIndex(tempJobs, function (o) {
                return o._id == currentJobId
              });


              if (foundJobIndex > -1) {

                console.log("Shukla tempJobs", tempJobs)
                console.log(" tempJobs[foundJobIndex] ", tempJobs[foundJobIndex])
                this.currentJob = tempJobs[foundJobIndex]
                this.courseComponet = this.currentJob.course.courseMetaId.components
                this.trackTime = this.currentJob.course.trackHours
                // this.isExamTab=this.currentJob.course.hasExam
                // this.isIlpForm=this.currentJob.course.hasIlpForm
                console.log("current selected job details", this.currentJob);
                this.courseFolderList = this.currentJob.courseFolder.sort((a, b) => a.unitNo - b.unitNo)
                this.courseUnitId = this.courseFolderList && this.courseFolderList.length ? this.courseFolderList[0]._id : null
                this.exams = (tempJobs[foundJobIndex].exams && tempJobs[foundJobIndex].exams.length && tempJobs[foundJobIndex].exams[0].exams) ? tempJobs[foundJobIndex].exams[0].exams : [];
                this.updateExams(this.exams)


                this.material = this.currentJob.readingMaterial
                this.assignments = []
                if (tempJobs[foundJobIndex].allotments && tempJobs[foundJobIndex].allotments.length) {
                  this.allAllotmentList = this.currentJob.allotments
                  tempJobs[foundJobIndex].allotments.forEach((item) => {
                    // console.log(" Tasg taga  assignment", assignment)
                    if (item.assignment.courseFolder == this.courseUnitId) {
                      this.assignments.push(item)
                    }
                    // this.assignments = tempJobs[foundJobIndex].allotments;
                  })


                  tempJobs[foundJobIndex].readingMaterial.forEach((item) => {
                    if (item.courseFolder == this.courseUnitId) {
                      // this.matre
                      let obj = {
                        assignment: item
                      }
                      this.assignments.push(obj)
                    }
                  })
                  this.assignmentsCopy = this.assignments;
                  this.updateData(this.assignments)
                }
                else {
                  console.log("call this else part");
                  tempJobs[foundJobIndex].readingMaterial.forEach((item) => {
                    if (item.courseFolder == this.courseUnitId) {
                      // this.matre
                      let obj = {
                        assignment: item
                      }
                      this.assignments.push(obj)
                    }
                  })
                  // this.assignments = [];
                  this.assignmentsCopy = this.assignments;
                  this.updateData(this.assignments)
                }



                console.log(" Hey yash Check this 1", this.assignments)

              }

            }
            else {

              console.log("call this else part it is for learner dashboard", this.learner.job);

              let tempJobs = JSON.parse(JSON.stringify(this.learner.job))
              let currentJobId = this.learner.job[0]._id
              let foundJobIndex = _.findIndex(tempJobs, function (o) { return o._id == currentJobId });
              this.jobId = currentJobId
              let otjtHours = this.learner.totalOTJH.find((x) => {
                if (x._id == this.jobId) return x
              })
              console.log("otjtHours testing", otjtHours);
              // if (otjtHours != undefined) {
              this.totalOTJH = otjtHours.totalOTJH ? otjtHours.totalOTJH : '00:00'
              // this.sendJobsToEditInstructorModal()
              if (this.learner.job && this.learner.job.length) {
                this.learnersJob = this.learner.job
                this.sendJobsToEditInstructorModal()
              }
              this.getJob()
              this.router.navigate(['/user/' + this.learnerId], { queryParams: { job: this.jobId } });
              // console.log(" Job is not Selected ")
              this.currentJob = tempJobs[foundJobIndex]
              this.trackTime = this.currentJob.course.trackHours
              this.isExamTab = this.currentJob.course.hasExam
              this.isIlpForm = this.currentJob.course.hasIlpForm
              console.log("hello here is the ::", this.trackTime)
              if (foundJobIndex > -1) {
                console.log(" Job is not Selected ")
                this.exams = (tempJobs[foundJobIndex].exams && tempJobs[foundJobIndex].exams.length && tempJobs[foundJobIndex].exams[0].exams) ? tempJobs[foundJobIndex].exams[0].exams : [];
                this.updateExams(this.exams)


                console.log(" tempJobs[foundJobIndex] ", tempJobs[foundJobIndex])

                tempJobs[foundJobIndex].allotments.forEach(() => {
                  this.assignments = tempJobs[foundJobIndex].allotments;
                  this.assignmentsCopy = this.assignments;
                  console.log(" Hey yash Check this 2", this.assignments)
                  this.updateData(this.assignments)
                })


              }
              this.courseComponet = this.currentJob.course.courseMetaId.components
            }


            this.loading = false;
          }
          console.log("This.learner", this.learner)

        });
    })
  }


  jobChanged(job) {
    console.log("job change data", job);

    this.jobId = job._id
    this.router.navigate(['/user/' + this.learnerId], { queryParams: { job: this.jobId } });
    this.getJob()
  }


  sendJobsToEditInstructorModal() {
    console.log("this function is call or not", this.learnersJob);
    let obj = {
      jobs: this.learnersJob,
      selectedJob: this.jobId
    }
    this._jobService.sendJobToEditInstructor(obj);
  }

  getJobFromJobsComponent() {
    // this._jobService.
  }

  instructorJobs() {
    let display = true
    this._learnerService.instructorJobs(display)
  }


  getTestedIndividual() {
    this.activatedRoute.params.subscribe(params => {
      console.log("Params User Id====>", params['id']);
      this._testedIndividualService.getTestedIndividual(params['id']).subscribe((res => {
        console.log('Tested Individual Res Here==>', res[0]);
        this.userDetails = res[0];
        // $(".learners_tab .mat-tab-labels .mat-tab-label:first-child").attr('hidden', true);

        this.showNonMedical = false
        this.loading = false;
      }))
    })
  }

  getPolicyData() {
    console.log("getting policy data", this.learnerId, this.jobId)
    this._learnerService.getPolicyData(this.learnerId, this.jobId).subscribe(res => {
      console.log("policy in learner dashboard", res)
      console.log("learner========>", this.learner)
      console.log("job =================>", this.job)
      if (res && res != null) {
        this.assessmentPlanEdit = res.details
      } else this.assessmentPlanEdit = null
    })
  }

  getEvidenceList() {
    console.log("evidence Refernce Here ...CAll");

    this._learnerService.getEvidenceByLearner(this.learnerId, this.jobId).subscribe(res => {
      console.log("evidence Refernce Here ...", res);
      if (res && res.length) {
        this.evidenceList = res
      }
    }, (error) => {
      console.log("Soeme error occure when Get EVi List", error)
    })
  }

  /**
   * @param type download type
   * @param jobId download for any specific job
   * Download the zip files of all documents of learner 
   */
  downloadLearnerDocuments(type, jobId?) {
    this.isLoading = true
    let obj = {
      type: type,
      learner: this.learner._id
    }
    if (jobId) obj['jobId'] = jobId
    this._utilityService.handleSnackBar({ msg: "It takes about 15 minutes to generate pdf. It will be mailed to you once the generation process is complete.", button: "Ok" });
    this._learnerService.downloadLearnerDocuments(obj).subscribe((data) => {
      console.log("This is the download data", data);
      this.isLoading = false
    }, err => {
      console.log("Error while generate zip file", err);
      this.isLoading = false
    })
  }
}
